module.exports = __webpack_public_path__ + "img/audio_classify10.52dde0d1.png";